
// import React, { useEffect, useState } from 'react';
// import { updateTimesheet } from '../core/helper/coreapicalls';


// const ApproveTimesheetForm = ({ timesheet, onUpdate, onClosePopup, onUpdateTimesheet }) => {
//   const [formData, setFormData] = useState({
//     timesheet_time_start: '',
//     timesheet_time_signin: '',
//     timesheet_time_signout: '',
//     timesheet_time_return: '',
//     timesheet_comments:'',
//     timesheet_expected_amount: 0,
//     timesheet_is_holiday: false,
//     timesheet_overtime_amount: 0,
//     timesheet_teamlead_approve: false,
//     isRejected: false,
//   });

//   useEffect(() => {
//     setFormData({
//       timesheet_time_start: timesheet.timesheet_time_start || '',
//       timesheet_time_signin: timesheet.timesheet_time_signin || '',
//       timesheet_time_signout: timesheet.timesheet_time_signout || '',
//       timesheet_time_return: timesheet.timesheet_time_return || '',
//       timesheet_comments:timesheet.timesheet_comments || '',
//       timesheet_expected_amount: timesheet.timesheet_expected_amount || 0,
//       timesheet_is_holiday: timesheet.timesheet_is_holiday || false,
//       timesheet_overtime_amount: timesheet.timesheet_overtime_amount || 0,
//       timesheet_teamlead_approve: timesheet.timesheet_teamlead_approve || false,
//       isRejected: timesheet.timesheet_is_reject || false,
//     });
//   }, [timesheet]);
// const handleChange = (e) => {
//   const { name, value, type, checked } = e.target;

//   const updatedValue =
//     type === "checkbox" ? checked : value;

//   const formattedTime = value || null;

//   setFormData((prevData) => ({
//     ...prevData,
//     [name]:
//       type === "time"
//         ? formattedTime
//         : updatedValue,
//   }));

//   if (
//     name === "timesheet_teamlead_approve" &&
//     value === "rejected"
//   ) {
//     setFormData((prevData) => ({
//       ...prevData,
//       isRejected: true,
//     }));
//   } else if (name === "timesheet_teamlead_approve") {
//     setFormData((prevData) => ({
//       ...prevData,
//       isRejected: false,
//     }));
//   }
// };



// //   const handleChange = (e) => {
// //     const { name, value, type, checked } = e.target;
// //     const updatedValue = type === 'checkbox' ? checked : value;

// //     const formattedTime = value ? `${value}:00` : null;

// //     setFormData((prevData) => ({
// //         ...prevData,
// //         [name]: type === 'time' ? formattedTime : updatedValue,
// //     }));

// //     if (name === 'timesheet_teamlead_approve' && value === 'rejected') {
// //         setFormData((prevData) => ({
// //             ...prevData,
// //             isRejected: true,
// //         }));
// //     } else {
// //         setFormData((prevData) => ({
// //             ...prevData,
// //             isRejected: false,
// //         }));
// //     }
// // };


//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (
//       !formData.timesheet_time_start ||
//       !formData.timesheet_time_signin ||
//       !formData.timesheet_time_signout ||
//       !formData.timesheet_time_return
//     ) {
//       alert('Please fill in all time fields.');
//       return;
//     }


//     try {

//       // onUpdateTimesheet(updatedTimesheet);

//       const confirmationMessage = `You entered the following times:\n
//         Time Start: ${formData.timesheet_time_start}\n
//         Time Sign In: ${formData.timesheet_time_signin}\n
//         Time Sign Out: ${formData.timesheet_time_signout}\n
//         Time Return: ${formData.timesheet_time_return}\n
//         Expected Amount: ${formData.timesheet_expected_amount}\n
//         Comments: ${formData.timesheet_comments}\n
//         Is Holiday: ${formData.timesheet_is_holiday ? 'Yes' : 'No'}\n
//         Overtime Amount: ${formData.timesheet_overtime_amount}\n
//         Team Lead Approval: ${formData.timesheet_teamlead_approve ? 'Approved' : 'Pending'}`;

//       if (window.confirm(confirmationMessage)) {
//         console.log("form dataaaaaaaaaaaaaaa",formData )

//       //   const updatedTimesheet = await updateTimesheet(timesheet.timesheet_id, {
//       //     ...formData,
//       //     timesheet_teamlead_approve: formData.isRejected ? false : formData.timesheet_teamlead_approve,
//       //     timesheet_is_reject: formData.isRejected,
//       // });


//         const payload = {
//           timesheet_time_start: formData.timesheet_time_start,
//           timesheet_time_signin: formData.timesheet_time_signin,
//           timesheet_time_signout: formData.timesheet_time_signout,
//           timesheet_time_return: formData.timesheet_time_return,
//           timesheet_comments: formData.timesheet_comments,
//           timesheet_is_holiday: formData.timesheet_is_holiday,
//           timesheet_is_reject: formData.isRejected,
//         };

//         // Team Lead approval
//         if (formData.timesheet_teamlead_approve !== undefined) {
//           payload.timesheet_teamlead_approve = formData.isRejected
//             ? false
//             : formData.timesheet_teamlead_approve;
//         }

//         // Manager approval - use this if same form is used for manager
//         if (timesheet.timesheet_dept_manager_approve !== undefined) {
//           payload.timesheet_dept_manager_approve =
//             formData.timesheet_dept_manager_approve;
//         }

//         const updatedTimesheet = await updateTimesheet(
//           timesheet.timesheet_id,
//           payload
//         );
            
//         onUpdate(updatedTimesheet);

//         alert('Timesheet updated successfully!');
//         // window.location.reload();
//       }
//     } catch (error) {
//       console.error('Error updating timesheet:', error);
//     } finally {
//       onClosePopup();
//     }
//   };
// return (
//   <div className="box popup" style={{ maxWidth: 600 }}>
//     <div className="popup-content">
//       <form onSubmit={handleSubmit}>

//         <button
//           type="button"
//           className="fa fa-window-close"
//           onClick={onClosePopup}
//         ></button>

//         {/* Time Start */}
//         <div className="form-group">
//           <label htmlFor="timesheet_time_start">
//             Time Start
//           </label>
//           <br />

//           <input
//             type="time"
//             step="1"
//             className="form-control input-box"
//             id="timesheet_time_start"
//             name="timesheet_time_start"
//             value={formData.timesheet_time_start || ""}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Time Sign In */}
//           <div className="form-group">
//             <label htmlFor="timesheet_time_signin">
//               Time Sign In
//             </label>
//             <br />

//             <input
//               type="time"
//               step="1"
//               className="form-control input-box"
//               id="timesheet_time_signin"
//               name="timesheet_time_signin"
//               value={formData.timesheet_time_signin || ""}
//               onChange={handleChange}
//             />
//           </div>

//         {/* Time Sign Out */}
//         <div className="form-group">
//           <label htmlFor="timesheet_time_signout">
//             Time Sign Out
//           </label>
//           <br />

//           <input
//             type="time"
//             step="1"
//             className="form-control input-box"
//             id="timesheet_time_signout"
//             name="timesheet_time_signout"
//             value={formData.timesheet_time_signout || ""}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Time Return */}
//         <div className="form-group">
//           <label htmlFor="timesheet_time_return">
//             Time Return
//           </label>
//           <br />

//           <input
//             type="time"
//             step="1"
//             className="form-control input-box"
//             id="timesheet_time_return"
//             name="timesheet_time_return"
//             value={formData.timesheet_time_return || ""}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Expected Amount */}
//         <div className="form-group">
//           <label htmlFor="timesheet_expected_amount">
//             Expected Amount
//           </label>

//           <input
//             className="form-control input-box"
//             type="number"
//             id="timesheet_expected_amount"
//             name="timesheet_expected_amount"
//             value={formData.timesheet_expected_amount}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Comments */}
//         <div className="form-group">
//           <label htmlFor="timesheet_comments">
//             Comments
//           </label>

//           <input
//             className="form-control input-box"
//             type="text"
//             id="timesheet_comments"
//             name="timesheet_comments"
//             value={formData.timesheet_comments}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Holiday */}
//         <div>
//           <input
//             type="checkbox"
//             id="timesheet_is_holiday"
//             name="timesheet_is_holiday"
//             checked={formData.timesheet_is_holiday}
//             onChange={handleChange}
//           />

//           <label htmlFor="timesheet_is_holiday">
//             Is Holiday
//           </label>
//         </div>

//         {/* Overtime Amount */}
//         <div className="form-group">
//           <label htmlFor="timesheet_overtime_amount">
//             Overtime Amount
//           </label>

//           <input
//             className="form-control input-box"
//             type="number"
//             id="timesheet_overtime_amount"
//             name="timesheet_overtime_amount"
//             value={formData.timesheet_overtime_amount}
//             onChange={handleChange}
//           />
//         </div>

//         {/* Approval */}
//         <div className="form-group">
//           <label htmlFor="timesheet_teamlead_approve">
//             Approval
//           </label>

//           <select
//             className="form-control input-box"
//             id="timesheet_teamlead_approve"
//             name="timesheet_teamlead_approve"
//             value={
//               formData.isRejected
//                 ? "rejected"
//                 : formData.timesheet_teamlead_approve
//             }
//             onChange={handleChange}
//           >
//             <option value={false}>Pending</option>
//             <option value={true}>Approved</option>
//           </select>
//         </div>

//         {/* Submit */}
//         <div className="form-group">
//           <button
//             type="submit"
//             className="btn1"
//           >
//             Submit
//           </button>
//         </div>

//       </form>
//     </div>
//   </div>
// );
// };

// export default ApproveTimesheetForm





// // import React, { useEffect, useState } from 'react';
// // import { updateTimesheet } from '../core/helper/coreapicalls';

// // const ApproveTimesheetForm = ({ timesheet, onUpdate, onClosePopup }) => {
// //   const [formData, setFormData] = useState({
// //     timesheet_time_start: '',
// //     timesheet_time_signin: '',
// //     timesheet_time_signout: '',
// //     timesheet_time_return: '',
// //     timesheet_expected_amount: 0,
// //     timesheet_is_holiday: false,
// //     timesheet_overtime_amount: 0,
// //     timesheet_teamlead_approve: false,
// //     // Add other Team Lead specific fields if needed
// //   });

// //   useEffect(() => {
// //     setFormData({
// //       timesheet_time_start: timesheet.timesheet_time_start || '',
// //       timesheet_time_signin: timesheet.timesheet_time_signin || '',
// //       timesheet_time_signout: timesheet.timesheet_time_signout || '',
// //       timesheet_time_return: timesheet.timesheet_time_return || '',
// //       timesheet_expected_amount: timesheet.timesheet_expected_amount || 0,
// //       timesheet_is_holiday: timesheet.timesheet_is_holiday || false,
// //       timesheet_overtime_amount: timesheet.timesheet_overtime_amount || 0,
// //       timesheet_teamlead_approve: timesheet.timesheet_teamlead_approve || false,
// //       // Update with other Team Lead specific fields if needed
// //     });
// //   }, [timesheet]);

// //   const handleChange = (e) => {
// //     const { name, value, type, checked } = e.target;
// //     const updatedValue = type === 'checkbox' ? checked : value;

// //     const formattedTime = value ? `${value}:00` : null;

// //     setFormData((prevData) => ({
// //       ...prevData,
// //       [name]: type === 'time' ? formattedTime : updatedValue,
// //     }));
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     if (
// //       !formData.timesheet_time_start ||
// //       !formData.timesheet_time_signin ||
// //       !formData.timesheet_time_signout ||
// //       !formData.timesheet_time_return
// //     ) {
// //       alert('Please fill in all time fields.');
// //       return;
// //     }

// //     try {
// //       const updatedTimesheet = await updateTimesheet(timesheet.timesheet_id, formData);

// //       const confirmationMessage = `You entered the following times:\n
// //         Time Start: ${formData.timesheet_time_start}\n
// //         Time Sign In: ${formData.timesheet_time_signin}\n
// //         Time Sign Out: ${formData.timesheet_time_signout}\n
// //         Time Return: ${formData.timesheet_time_return}\n
// //         Expected Amount: ${formData.timesheet_expected_amount}\n
// //         Is Holiday: ${formData.timesheet_is_holiday ? 'Yes' : 'No'}\n
// //         Overtime Amount: ${formData.timesheet_overtime_amount}\n
// //         Team Lead Approval: ${formData.timesheet_teamlead_approve ? 'Approved' : 'Pending'}`;

// //       if (window.confirm(confirmationMessage)) {
// //         onUpdate(updatedTimesheet);
// //         alert('Timesheet updated successfully!');
// //       }
// //     } catch (error) {
// //       console.error('Error updating timesheet:', error);
// //     } finally {
// //       onClosePopup();
// //     }
// //   };

// //   return (
// //     <div className="box popup">
// //       <div className="popup-content">
// //         <form onSubmit={handleSubmit}>
// //           <button className='fa fa-window-close' onClick={onClosePopup}></button>
// //           {/* Form fields */}
// //           {/* ... (add your form fields here) */}
// //           <div className="form-group">
// //             <button type="submit" className="btn1">Submit</button>
// //           </div>
// //         </form>
// //       </div>
// //     </div>
// //   );
// // };

// // export default ApproveTimesheetForm;


import React, { useEffect, useState } from 'react';
import { updateTimesheet } from '../core/helper/coreapicalls';
import TimePicker24 from "./TimePicker24";


const ApproveTimesheetForm = ({ timesheet, onUpdate, onClosePopup, onUpdateTimesheet }) => {
  const [formData, setFormData] = useState({
    timesheet_time_start: '',
    timesheet_time_signin: '',
    timesheet_time_signout: '',
    timesheet_time_return: '',
    timesheet_comments:'',
    timesheet_expected_amount: 0,
    timesheet_is_holiday: false,
    timesheet_overtime_amount: 0,
    timesheet_teamlead_approve: false,
    isRejected: false,
  });

  const [validationErrors, setValidationErrors] = useState([]);

  const isValidTime24 = (time) => {
    return /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(time);
  };

  const handleTimeChange = (fieldName, value) => {
    const updatedData = {
      ...formData,
      [fieldName]: value || "",
    };

    setFormData(updatedData);
    validateTimes(updatedData);
  };

  const validateTimes = (data) => {
    const errors = [];

    const timeFields = [
      ["timesheet_time_start", "Time Start"],
      ["timesheet_time_signin", "Time Sign In"],
      ["timesheet_time_signout", "Time Sign Out"],
      ["timesheet_time_return", "Time Return"],
    ];

    timeFields.forEach(([field, label]) => {
      if (data[field] && !isValidTime24(data[field])) {
        errors.push(`${label} must be a valid 24-hour time in HH:MM:SS format.`);
      }
    });

    const startValid =
      data.timesheet_time_start && isValidTime24(data.timesheet_time_start);
    const signinValid =
      data.timesheet_time_signin && isValidTime24(data.timesheet_time_signin);
    const signoutValid =
      data.timesheet_time_signout && isValidTime24(data.timesheet_time_signout);
    const returnValid =
      data.timesheet_time_return && isValidTime24(data.timesheet_time_return);

    if (startValid && signinValid) {
      const startTime = new Date(`1970-01-01T${data.timesheet_time_start}`);
      const signinTime = new Date(`1970-01-01T${data.timesheet_time_signin}`);

      if (signinTime < startTime) {
        errors.push("Sign In Time cannot be before Start Time.");
      }
    }

    if (startValid && signinValid && signoutValid) {
      const startTime = new Date(`1970-01-01T${data.timesheet_time_start}`);
      const signinTime = new Date(`1970-01-01T${data.timesheet_time_signin}`);
      const signoutTime = new Date(`1970-01-01T${data.timesheet_time_signout}`);

      if (signoutTime < signinTime || signoutTime < startTime) {
        errors.push("Please check Sign Out Time.");
      }
    }

    if (startValid && signinValid && signoutValid && returnValid) {
      const startTime = new Date(`1970-01-01T${data.timesheet_time_start}`);
      const signinTime = new Date(`1970-01-01T${data.timesheet_time_signin}`);
      const signoutTime = new Date(`1970-01-01T${data.timesheet_time_signout}`);
      const returnTime = new Date(`1970-01-01T${data.timesheet_time_return}`);

      if (
        returnTime < signoutTime ||
        returnTime < startTime ||
        returnTime < signinTime
      ) {
        errors.push("Please check Return Time.");
      }
    }

    setValidationErrors(errors);
    return errors;
  };

  const setQuickTime = (fieldName, timeValue) => {
    handleTimeChange(fieldName, timeValue);
  };



  useEffect(() => {
    setFormData({
      timesheet_time_start: timesheet.timesheet_time_start || '',
      timesheet_time_signin: timesheet.timesheet_time_signin || '',
      timesheet_time_signout: timesheet.timesheet_time_signout || '',
      timesheet_time_return: timesheet.timesheet_time_return || '',
      timesheet_comments:timesheet.timesheet_comments || '',
      timesheet_expected_amount: timesheet.timesheet_expected_amount || 0,
      timesheet_is_holiday: timesheet.timesheet_is_holiday || false,
      timesheet_overtime_amount: timesheet.timesheet_overtime_amount || 0,
      timesheet_teamlead_approve: timesheet.timesheet_teamlead_approve || false,
      isRejected: timesheet.timesheet_is_reject || false,
    });
  }, [timesheet]);
const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  const updatedValue =
    type === "checkbox" ? checked : value;

  const formattedTime = value || null;

  setFormData((prevData) => ({
    ...prevData,
    [name]:
      type === "time"
        ? formattedTime
        : updatedValue,
  }));

  if (
    name === "timesheet_teamlead_approve" &&
    value === "rejected"
  ) {
    setFormData((prevData) => ({
      ...prevData,
      isRejected: true,
    }));
  } else if (name === "timesheet_teamlead_approve") {
    setFormData((prevData) => ({
      ...prevData,
      isRejected: false,
    }));
  }
};



//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     const updatedValue = type === 'checkbox' ? checked : value;

//     const formattedTime = value ? `${value}:00` : null;

//     setFormData((prevData) => ({
//         ...prevData,
//         [name]: type === 'time' ? formattedTime : updatedValue,
//     }));

//     if (name === 'timesheet_teamlead_approve' && value === 'rejected') {
//         setFormData((prevData) => ({
//             ...prevData,
//             isRejected: true,
//         }));
//     } else {
//         setFormData((prevData) => ({
//             ...prevData,
//             isRejected: false,
//         }));
//     }
// };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.timesheet_time_start ||
      !formData.timesheet_time_signin ||
      !formData.timesheet_time_signout ||
      !formData.timesheet_time_return
    ) {
      alert('Please fill in all time fields.');
      return;
    }

    const finalErrors = validateTimes(formData);

    if (finalErrors.length > 0) {
      alert("Please fix the following errors:\n" + finalErrors.join("\n"));
      return;
    }


    try {

      // onUpdateTimesheet(updatedTimesheet);

      const confirmationMessage = `You entered the following times:\n
        Time Start: ${formData.timesheet_time_start}\n
        Time Sign In: ${formData.timesheet_time_signin}\n
        Time Sign Out: ${formData.timesheet_time_signout}\n
        Time Return: ${formData.timesheet_time_return}\n
        Expected Amount: ${formData.timesheet_expected_amount}\n
        Comments: ${formData.timesheet_comments}\n
        Is Holiday: ${formData.timesheet_is_holiday ? 'Yes' : 'No'}\n
        Overtime Amount: ${formData.timesheet_overtime_amount}\n
        Team Lead Approval: ${formData.timesheet_teamlead_approve ? 'Approved' : 'Pending'}`;

      if (window.confirm(confirmationMessage)) {
        console.log("form dataaaaaaaaaaaaaaa",formData )

      //   const updatedTimesheet = await updateTimesheet(timesheet.timesheet_id, {
      //     ...formData,
      //     timesheet_teamlead_approve: formData.isRejected ? false : formData.timesheet_teamlead_approve,
      //     timesheet_is_reject: formData.isRejected,
      // });


        const payload = {
          timesheet_time_start: formData.timesheet_time_start,
          timesheet_time_signin: formData.timesheet_time_signin,
          timesheet_time_signout: formData.timesheet_time_signout,
          timesheet_time_return: formData.timesheet_time_return,
          timesheet_comments: formData.timesheet_comments,
          timesheet_is_holiday: formData.timesheet_is_holiday,
          timesheet_is_reject: formData.isRejected,
        };

        // Team Lead approval
        if (formData.timesheet_teamlead_approve !== undefined) {
          payload.timesheet_teamlead_approve = formData.isRejected
            ? false
            : formData.timesheet_teamlead_approve;
        }

        // Manager approval - use this if same form is used for manager
        if (timesheet.timesheet_dept_manager_approve !== undefined) {
          payload.timesheet_dept_manager_approve =
            formData.timesheet_dept_manager_approve;
        }

        const updatedTimesheet = await updateTimesheet(
          timesheet.timesheet_id,
          payload
        );
            
        onUpdate(updatedTimesheet);

        alert('Timesheet updated successfully!');
        // window.location.reload();
      }
    } catch (error) {
      console.error('Error updating timesheet:', error);
    } finally {
      onClosePopup();
    }
  };
return (
  <div className="box popup" style={{ maxWidth: 600 }}>
    <div className="popup-content">
      <form onSubmit={handleSubmit}>

        <button
          type="button"
          className="fa fa-window-close"
          onClick={onClosePopup}
        ></button>

        {/* Time Start */}
        <div className="form-group">
          <label htmlFor="timesheet_time_start">
            Time Start
          </label>
          <br />

          <TimePicker24
            value={formData.timesheet_time_start}
            onChange={(value) =>
              handleTimeChange("timesheet_time_start", value)
            }
          />

          <button
            type="button"
            className="btn btn-sm btn-secondary m-1"
            onClick={() => setQuickTime("timesheet_time_start", "00:00:00")}
          >
            00:00:00
          </button>

          <button
            type="button"
            className="btn btn-sm btn-secondary m-1"
            onClick={() => setQuickTime("timesheet_time_start", "08:00:00")}
          >
            08:00:00
          </button>
        </div>

        {/* Time Sign In */}
          <div className="form-group">
            <label htmlFor="timesheet_time_signin">
              Time Sign In
            </label>
            <br />

              <TimePicker24
              value={formData.timesheet_time_signin}
              onChange={(value) =>
                handleTimeChange("timesheet_time_signin", value)
              }
            />

            <button
              type="button"
              className="btn btn-sm btn-secondary m-1"
              onClick={() => setQuickTime("timesheet_time_signin", "00:00:00")}
            >
              00:00:00
            </button>

            <button
              type="button"
              className="btn btn-sm btn-secondary m-1"
              onClick={() => setQuickTime("timesheet_time_signin", "08:00:00")}
            >
              08:00:00
            </button>
          </div>

        {/* Time Sign Out */}
        <div className="form-group">
          <label htmlFor="timesheet_time_signout">
            Time Sign Out
          </label>
          <br />

          <TimePicker24
            value={formData.timesheet_time_signout}
            onChange={(value) =>
              handleTimeChange("timesheet_time_signout", value)
            }
          />

          <button
            type="button"
            className="btn btn-sm btn-secondary m-1"
            onClick={() => setQuickTime("timesheet_time_signout", "18:00:00")}
          >
            18:00:00
          </button>

          <button
            type="button"
            className="btn btn-sm btn-secondary m-1"
            onClick={() => setQuickTime("timesheet_time_signout", "23:59:59")}
          >
            23:59:59
          </button>
        </div>

        {/* Time Return */}
        <div className="form-group">
          <label htmlFor="timesheet_time_return">
            Time Return
          </label>
          <br />

          <TimePicker24
            value={formData.timesheet_time_return}
            onChange={(value) =>
              handleTimeChange("timesheet_time_return", value)
            }
          />

          <button
            type="button"
            className="btn btn-sm btn-secondary m-1"
            onClick={() => setQuickTime("timesheet_time_return", "23:59:59")}
          >
            23:59:59
          </button>
        </div>

        {validationErrors.length > 0 && (
          <div
            className="alert alert-danger mt-2"
            style={{ fontSize: "12px" }}
          >
            {validationErrors.map((error, index) => (
              <div key={index}>{error}</div>
            ))}
          </div>
        )}

        {/* Expected Amount */}
        <div className="form-group">
          <label htmlFor="timesheet_expected_amount">
            Expected Amount
          </label>

          <input
            className="form-control input-box"
            type="number"
            id="timesheet_expected_amount"
            name="timesheet_expected_amount"
            value={formData.timesheet_expected_amount}
            onChange={handleChange}
          />
        </div>

        {/* Comments */}
        <div className="form-group">
          <label htmlFor="timesheet_comments">
            Comments
          </label>

          <input
            className="form-control input-box"
            type="text"
            id="timesheet_comments"
            name="timesheet_comments"
            value={formData.timesheet_comments}
            onChange={handleChange}
          />
        </div>

        {/* Holiday */}
        <div>
          <input
            type="checkbox"
            id="timesheet_is_holiday"
            name="timesheet_is_holiday"
            checked={formData.timesheet_is_holiday}
            onChange={handleChange}
          />

          <label htmlFor="timesheet_is_holiday">
            Is Holiday
          </label>
        </div>

        {/* Overtime Amount */}
        <div className="form-group">
          <label htmlFor="timesheet_overtime_amount">
            Overtime Amount
          </label>

          <input
            className="form-control input-box"
            type="number"
            id="timesheet_overtime_amount"
            name="timesheet_overtime_amount"
            value={formData.timesheet_overtime_amount}
            onChange={handleChange}
          />
        </div>

        {/* Approval */}
        <div className="form-group">
          <label htmlFor="timesheet_teamlead_approve">
            Approval
          </label>

          <select
            className="form-control input-box"
            id="timesheet_teamlead_approve"
            name="timesheet_teamlead_approve"
            value={
              formData.isRejected
                ? "rejected"
                : formData.timesheet_teamlead_approve
            }
            onChange={handleChange}
          >
            <option value={false}>Pending</option>
            <option value={true}>Approved</option>
          </select>
        </div>

        {/* Submit */}
        <div className="form-group">
          <button
            type="submit"
            className="btn1"
          >
            Submit
          </button>
        </div>

      </form>
    </div>
  </div>
);
};

export default ApproveTimesheetForm





// import React, { useEffect, useState } from 'react';
// import { updateTimesheet } from '../core/helper/coreapicalls';

// const ApproveTimesheetForm = ({ timesheet, onUpdate, onClosePopup }) => {
//   const [formData, setFormData] = useState({
//     timesheet_time_start: '',
//     timesheet_time_signin: '',
//     timesheet_time_signout: '',
//     timesheet_time_return: '',
//     timesheet_expected_amount: 0,
//     timesheet_is_holiday: false,
//     timesheet_overtime_amount: 0,
//     timesheet_teamlead_approve: false,
//     // Add other Team Lead specific fields if needed
//   });

//   useEffect(() => {
//     setFormData({
//       timesheet_time_start: timesheet.timesheet_time_start || '',
//       timesheet_time_signin: timesheet.timesheet_time_signin || '',
//       timesheet_time_signout: timesheet.timesheet_time_signout || '',
//       timesheet_time_return: timesheet.timesheet_time_return || '',
//       timesheet_expected_amount: timesheet.timesheet_expected_amount || 0,
//       timesheet_is_holiday: timesheet.timesheet_is_holiday || false,
//       timesheet_overtime_amount: timesheet.timesheet_overtime_amount || 0,
//       timesheet_teamlead_approve: timesheet.timesheet_teamlead_approve || false,
//       // Update with other Team Lead specific fields if needed
//     });
//   }, [timesheet]);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     const updatedValue = type === 'checkbox' ? checked : value;

//     const formattedTime = value ? `${value}:00` : null;

//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: type === 'time' ? formattedTime : updatedValue,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (
//       !formData.timesheet_time_start ||
//       !formData.timesheet_time_signin ||
//       !formData.timesheet_time_signout ||
//       !formData.timesheet_time_return
//     ) {
//       alert('Please fill in all time fields.');
//       return;
//     }

//     try {
//       const updatedTimesheet = await updateTimesheet(timesheet.timesheet_id, formData);

//       const confirmationMessage = `You entered the following times:\n
//         Time Start: ${formData.timesheet_time_start}\n
//         Time Sign In: ${formData.timesheet_time_signin}\n
//         Time Sign Out: ${formData.timesheet_time_signout}\n
//         Time Return: ${formData.timesheet_time_return}\n
//         Expected Amount: ${formData.timesheet_expected_amount}\n
//         Is Holiday: ${formData.timesheet_is_holiday ? 'Yes' : 'No'}\n
//         Overtime Amount: ${formData.timesheet_overtime_amount}\n
//         Team Lead Approval: ${formData.timesheet_teamlead_approve ? 'Approved' : 'Pending'}`;

//       if (window.confirm(confirmationMessage)) {
//         onUpdate(updatedTimesheet);
//         alert('Timesheet updated successfully!');
//       }
//     } catch (error) {
//       console.error('Error updating timesheet:', error);
//     } finally {
//       onClosePopup();
//     }
//   };

//   return (
//     <div className="box popup">
//       <div className="popup-content">
//         <form onSubmit={handleSubmit}>
//           <button className='fa fa-window-close' onClick={onClosePopup}></button>
//           {/* Form fields */}
//           {/* ... (add your form fields here) */}
//           <div className="form-group">
//             <button type="submit" className="btn1">Submit</button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ApproveTimesheetForm;